import $ from 'jquery';

$(document).ready(function () {
  // タブ
  $('.js-tab-container').each(function () {
    if ($(this).find('.js-tab').length > 0) {
      $(this).find('.js-tab-content').eq($('.js-tab.active').index()).fadeIn(); // あらかじめactiveなタブを開いておく
      $(this).find('.js-tab').on('click', function (e) {
        e.preventDefault();
        var container = $(this).closest('.js-tab-container');
        container.find('.js-tab').removeClass('active');
        $(this).addClass('active');
        container.find('.js-tab-content').hide();
        container.find('.js-tab-content').eq($(this).index()).fadeIn();
      });
    }
  });

  const tabs = Array.prototype.slice.call(document.querySelectorAll('[role="tab"]'), 0);
  if (tabs) {
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();

        const self = event.target;
        // タブのラッパを取得
        const wrapper = self.closest('[data-tab-wrapper]');

        if (self.getAttribute('aria-selected') === 'false') {
          // アコーディオンでなければ自分以外全部閉じる
          if (wrapper.getAttribute('data-tab-wrapper') !== 'accordion') {
            tabs.forEach(function (item) {
              item.setAttribute('aria-selected', item == self);
            });

            // タブコンテンツも合わせる
            const tabContents = Array.prototype.slice.call(wrapper.querySelectorAll('[role="tabpanel"]'), 0);
            tabContents.forEach(function (item) {
              item.setAttribute('aria-hidden', true);
            });
            const target = self.getAttribute('aria-controls');
            document
              .getElementById(target)
              .setAttribute('aria-hidden', false);
          } else {
            // アコーディオンなら自分を開くだけ
            self.setAttribute('aria-selected', true);
            document
              .getElementById(self.getAttribute('aria-controls'))
              .setAttribute('aria-hidden', false);
          }
        } else {
          // 選択されているかつタブでないなら閉じる
          if (wrapper.getAttribute('data-tab-wrapper') !== 'tab') {
            self.setAttribute('aria-selected', false);
            document
              .getElementById(self.getAttribute('aria-controls'))
              .setAttribute('aria-hidden', true);
          }
        }
      });
    });
  }
});

// closest ポリフィル
if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest =
    function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i,
        el = this;
      do {
        i = matches.length;
        while (--i >= 0 && matches.item(i) !== el) {
          //
        }
      } while ((i < 0) && (el = el.parentElement));
      return el;
    };
}